/**
 * Webpack 5 compatibility utilities
 * Fixes common issues when migrating from webpack 4 to webpack 5
 */

/**
 * Polyfill for Node.js modules that are no longer automatically polyfilled in webpack 5
 * This should be imported at the top of your main entry file (index.js)
 */
export const webpack5Polyfills = () => {
    // Polyfill for Node.js modules
    if (typeof global === 'undefined') {
      window.global = window;
    }
    
    // Polyfill for Buffer if not available
    if (typeof Buffer === 'undefined') {
      window.Buffer = window.Buffer || {};
    }
    
    // Polyfill for process if not available
    if (typeof process === 'undefined') {
      window.process = {
        env: {
          NODE_ENV: 'development',
          PUBLIC_URL: ''
        },
        browser: true,
        version: '16.0.0',
        versions: {},
        platform: 'browser',
        arch: 'x64',
        argv: [],
        cwd: () => '/',
        chdir: () => {},
        umask: () => 0,
        hrtime: () => [0, 0],
        nextTick: (fn) => setTimeout(fn, 0),
        exit: () => {},
        kill: () => {},
        on: () => {},
        addListener: () => {},
        once: () => {},
        removeListener: () => {},
        removeAllListeners: () => {},
        emit: () => {},
        prependListener: () => {},
        prependOnceListener: () => {},
        listeners: () => [],
        binding: () => {},
        cwd: () => '/',
        chdir: () => {},
        umask: () => 0,
        hrtime: () => [0, 0],
        nextTick: (fn) => setTimeout(fn, 0),
        exit: () => {},
        kill: () => {},
        on: () => {},
        addListener: () => {},
        once: () => {},
        removeListener: () => {},
        removeAllListeners: () => {},
        emit: () => {},
        prependListener: () => {},
        prependOnceListener: () => {},
        listeners: () => [],
        binding: () => {}
      };
    }
  };
  
  /**
   * Fix for querystring module compatibility
   * Provides a fallback for querystring parsing
   */
  export const parseQueryString = (search) => {
    if (!search) return {};
    
    // Remove the '?' at the beginning
    const queryString = search.startsWith('?') ? search.slice(1) : search;
    
    if (!queryString) return {};
    
    // Simple query string parser
    return queryString.split('&').reduce((params, param) => {
      const [key, value] = param.split('=');
      if (key) {
        params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
      }
      return params;
    }, {});
  };
  
  /**
   * Fix for React Router v6 compatibility with class components
   * Provides a wrapper that handles the transition from v5 to v6
   */
  export const createRouterCompatibility = () => {
    // This function can be used to set up any additional compatibility measures
    // that might be needed for the router transition
    return {
      // Add any additional compatibility measures here
    };
  };
  
  /**
   * Webpack 5 module resolution fix
   * Helps with module resolution issues when upgrading to webpack 5
   */
  export const webpack5ModuleResolution = {
    // These can be added to webpack.config.js resolve.fallback
    fallback: {
      "path": false,
      "fs": false,
      "crypto": false,
      "stream": false,
      "util": false,
      "buffer": false,
      "process": false
    }
  };
  
  export default {
    webpack5Polyfills,
    parseQueryString,
    createRouterCompatibility,
    webpack5ModuleResolution
  };
  